import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { Area, Category } from '@ilteducation/content-ref-data-types';
import { UploadedFile, VideoV1 } from '@ilteducation/content-registry-types';
import { getAllRefData } from '@/data-provider/refDataProvider';
import DisableableButton from '@/components/buttons/DisableableButton.vue';

type UploadedFileWithId = {
  id: string;
} & UploadedFile;

type Props = {
  item: VideoV1;
  market: string;
  files: UploadedFileWithId[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSubjectAreaConnector',
  props: {
    item: null,
    market: null,
    files: null
  },
  emits: ["done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'done', areaId: Area['id'], categoryId: Category['id'], fileId: UploadedFileWithId['id'], market: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: VideoV1;
  market: string;
  files: UploadedFileWithId[];
}





const selectedCategory = ref<Category['id']>('');
const selectedArea = ref<Area['id']>('');
const selectedFile = ref<UploadedFileWithId['id']>();

const add = async () => {
  emit('done', selectedArea.value, selectedCategory.value, selectedFile.value!, props.market);
};

const availableCategories = ref<Category[]>([]);
getAllRefData('categories').then((categories: Category[]) => {
  availableCategories.value = categories.filter((c) => c.subscriptionTypes?.some((t) => t.startsWith('immigrant')));
});

const availableAreas = ref<Area[]>([]);
getAllRefData('areas').then((areas) => {
  availableAreas.value = areas;
});

const getFileNameWithVersion = (file: UploadedFile) => `${file.originalFileName || file.fileName} ${file.uploadedAt ? `(${new Date(file.uploadedAt).toLocaleString('sv-SE')})` : ''}`;

const getCategoryNameWithSwedish = (category: Category) => {
  if (props.market === 'se') {
    return category.category;
  }
  const sweCategory = availableCategories.value.filter(
    (c) => c.categoryCode === category.categoryCode && c.realms && c.realms.includes('se'),
  )[0];
  return `${category.category} (${sweCategory?.category || 'Unknown'})`;
};

const availableFiles = computed(() => props.files.filter((f) => f.isProcessed));

const uploadDisabled = computed(() => !selectedFile.value || !selectedCategory.value || !selectedArea.value);

return { __sfc: true,props, emit, selectedCategory, selectedArea, selectedFile, add, availableCategories, availableAreas, getFileNameWithVersion, getCategoryNameWithSwedish, availableFiles, uploadDisabled, DisableableButton }
}

})